import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../services/api';
import { Button } from "../components/ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";
import { Input } from "../components/ui/Input";
import { Label } from "../components/ui/Label";
import { Eye, EyeOff } from 'lucide-react'; // Importar ícones

function RegisterPage() {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [instituicao, setInstituicao] = useState('');
    const [grauAcademico, setGrauAcademico] = useState(''); // NOVO ESTADO
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // Estado para visibilidade da senha
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsLoading(true);

        if (!nome || !email || !senha) {
            setError('Por favor, preencha todos os campos obrigatórios.');
            setIsLoading(false);
            return;
        }

        try {
            await registerUser({ nome, email, senha, instituicao, grauAcademico }); // Incluir grauAcademico no payload

            setSuccess('Registro realizado com sucesso! A redirecionar para o login...');
            setNome('');
            setEmail('');
            setSenha('');
            setInstituicao('');
            setGrauAcademico(''); // Limpar campo
            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (err) {
            console.error('Erro de registro:', err.message);
            setError(err.message || 'Ocorreu um erro ao tentar registrar.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <Card className="w-full max-w-sm my-8"> {/* Adicionado my-8 aqui */}
                <CardHeader className="text-center">
                    <img src="/ucm-logo.png" alt="Gestão de Presenças Logo" className="w-24 h-auto mx-auto mb-4" />
                    <p className="text-sm text-muted-foreground mb-2">Universidade Católica de Moçambique</p>
                    <CardTitle className="text-2xl">Gestão de Presenças</CardTitle>
                </CardHeader>
                <form onSubmit={handleRegister}>
                    <CardContent className="grid gap-4">
                        {success && <p className="text-sm font-medium text-green-600">{success}</p>}
                        {error && <p className="text-sm font-medium text-destructive">{error}</p>}

                        <div className="grid gap-2">
                            <Label htmlFor="nome" className="mb-1">Nome Completo</Label> {/* Adicionado mb-1 */}
                            <Input
                                id="nome"
                                type="text"
                                placeholder="Seu Nome Completo"
                                required
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="email" className="mb-1">Email</Label> {/* Adicionado mb-1 */}
                            <Input
                                id="email"
                                type="email"
                                placeholder="m@exemplo.com"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="grauAcademico" className="mb-1">Grau Acadêmico (Opcional)</Label> {/* NOVO CAMPO */}
                            <Input
                                id="grauAcademico"
                                type="text"
                                placeholder="Ex: Licenciatura, Mestrado"
                                value={grauAcademico}
                                onChange={(e) => setGrauAcademico(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="instituicao" className="mb-1">Instituição (Opcional)</Label> {/* Adicionado mb-1 */}
                            <Input
                                id="instituicao"
                                type="text"
                                placeholder="Nome da sua instituição"
                                value={instituicao}
                                onChange={(e) => setInstituicao(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="senha" className="mb-1">Senha</Label> {/* Adicionado mb-1 */}
                            <div className="relative">
                                <Input
                                    id="senha"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Sua senha"
                                    required
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    disabled={isLoading}
                                    className="pr-10"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground hover:text-primary transition-colors" // Adicionado transições
                                    disabled={isLoading}
                                >
                                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                </button>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex flex-col">
                        <Button className="w-full" type="submit" disabled={isLoading}>
                            {isLoading ? 'A registar...' : 'Registar'}
                        </Button>
                        <p className="mt-4 text-xs text-center text-muted-foreground">
                            Já tem conta?{" "}
                            <Link to="/login" className="underline transition-colors hover:text-primary"> {/* Adicionado transições */}
                                Faça login aqui
                            </Link>
                        </p>
                    </CardFooter>
                </form>
            </Card>
        </div>
    );
}

export default RegisterPage;